
export default {
    name: 'index',
    data() {
        return {
            info:{},
            stockcode:'',
            loading:null, 
            dataresult:{info:{zuixinjia:''}},
            dataItme2:{},
            ifloading:false,
            historyData:{zuigaojia:'',zuidijia:'',data:[]}, 
            Skip:1,
            Limit:10,
          
            total:0,
            querry:{
                beginTime:new Date(new Date().getFullYear()-1,0,1).Format('yyyy-MM-dd'),
                endTime:new Date(new Date().getFullYear()-1,11,31).Format('yyyy-MM-dd'),
                stockType:'us',
                skip:1,
                limit:10 
            }
      


        };
    },
    methods: {
        // 用于初始化一些数据
        init() {
            if(this.$route.query.code!=null &&this.$route.query.code!=undefined){
                
                this.SearchCompanyInfoByCode(); 
                this.SearchEveryDayInfo()
                this.SearchHistory()

            }
        },
        // 用于更新一些数据
        async SearchCompanyInfoByCode() {
            this.stockcode=this.$route.query.code
            this.ifloading=true;
            var that=this

            const res = await this.$http.post('DownEast/SearchCompanyInfoByCode', {code:this.stockcode });
            if(res.Status)
            { 
                this.info=res.Result;
            }
            this.ifloading=false
           
        }, 
        async SearchHistory() {
            var that=this 
            that.querry.code=that.stockcode
            this.showLoading('数据加载中') 
            that.querry.skip=that.Skip
            that.querry.limit=that.Limit
            const res = await this.$http.post('StockEveryDayInfo/SearchStockHistoryInfo',that.querry);
            if(res.Status){    
               this.total=res.Total
                res.Result.History.forEach(function (v) {  
                    v.chengjiaoliang=that.Bigmoney(v.chengjiaoliang)
                })

                that.historyData.data=res.Result.History; 
                that.historyData.zuigaojia=res.Result.Zuigao;
                that.historyData.zuidijia=res.Result.Zuidi;
                that.historyData.code=res.Result.Code



                console.warn(res.Result)
                this.close();
            } 
            else if(res.Msg=="待下载")
            {  
              //  this.DownUsStockHistory(); 
               
            } 

            

        },

        
        async DownUsStockHistory() {

            this.showLoading('数据下载中') 
            const res = await this.$http.post('DownYh/DownUsStockHistory', {code:this.stockcode });
            if(res.Status){ 
                this.$success('下载成功！'); 
                this.SearchHistory();
                this.close();
            }
            else
            { 
                this.close();
            }

        },

        async SearchEveryDayInfo() {
            var that=this

            this.showLoading('数据加载中') 
            const res = await this.$http.post('StockEveryDayInfo/GetStockEveryDayInfo', {code:this.stockcode });
            if(res.Status){   
                res.Result.Item1.info.zongguben=that.Bigmoney(res.Result.Item1.info.zongguben)
                res.Result.Item1.info.zongshizhi=that.Bigmoney(res.Result.Item1.info.zongshizhi)
                res.Result.Item1.info.chengjiaoliang=that.Bigmoney(res.Result.Item1.info.chengjiaoliang)
                res.Result.Item1.info.chengjiaoe=that.Bigmoney(res.Result.Item1.info.chengjiaoe)
                res.Result.Item1.info.waipan=that.Bigmoney(res.Result.Item1.info.waipan)
                res.Result.Item1.info.neipan=that.Bigmoney(res.Result.Item1.info.neipan)
             
                that.dataresult=res.Result.Item1; 
             
                res.Result.Item2.forEach(function (v) {  
                 if(v[0]=="收入预估"){

                    v[1]=that.Bigmoney(v[1])
                    v[2]=that.Bigmoney(v[2])
                    v[3]=that.Bigmoney(v[3])

                 }
                })

                that.dataItme2=res.Result.Item2; 

                console.warn(res.Result.Item1)
                this.close();
            } 
            else if(res.Msg=="待下载")
            {  
              //  this.DownEveryDayInfo(); 
               
            }    

        },
        
        async DownEveryDayInfo() {

            this.showLoading('数据下载中') 
            const res = await this.$http.post('StockEveryDayInfo/DownStockEveryDayInfo', {code:this.stockcode });
            if(res.Status){ 
                this.$success('下载成功！'); 
                this.SearchEveryDayInfo();
                this.close();
            }
            else
            { 
                this.close();
            }

        },
        close() { 
            if(this.loading)
            this.loading.close();
        },
        showLoading(txt) {
            this.close();
            this.loading = this.$loading({
                lock: true,
                text: txt+'……',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
        }, 
        Bigmoney(value){
            var param = {};
            var k = 10000,
                sizes = ['', '万', '亿', '万亿'],
                i;
            if (value < k) {
                param.value = value
                param.unit = ''
            } else {
                i = Math.floor(Math.log(value) / Math.log(k));
        
                param.value = ((value / Math.pow(k, i))).toFixed(2);
                param.unit = sizes[i];
            }
            return param.value+param.unit;
        }

    },
    // 计算属性
    computed: {
        identity() {
            let identity = '园长';
            return identity;
        }
    },
    // 包含 Vue 实例可用过滤器的哈希表。
    filters: {},
    // 在实例创建完成后被立即调用
    created() { },
    // 在挂载开始之前被调用：相关的 render 函数首次被调用。
    beforeMount() {
       // this.update(); 
    },
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
    mounted() {
        this.$nextTick(() => { 
            this.init(); 
         });
    },
    beforeCreate () {
       
      },
    // 数据更新时调用，发生在虚拟 DOM 打补丁之前。
    beforeUpdate() { 
        
    },
    // keep-alive 组件激活时调用。
    activated() { },
    // keep-alive 组件停用时调用。
    deactivated() { },
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
    beforeDestroy() { },
    //Vue 实例销毁后调用。
    destroyed() { },
    // 当捕获一个来自子孙组件的错误时被调用。
    errorCaptured() { },
    // 包含 Vue 实例可用指令的哈希表。
    directives: {},
    // 一个对象，键是需要观察的表达式，值是对应回调函数。
    watch: {
        
        //监听相同路由下参数变化的时候，从而实现异步刷新
        $route(to,from) { 
            this.init(); 
        },
        Skip() {
            this.SearchHistory();

        },
        Limit() {
            this.SearchHistory();

        },
    },
    // 组件列表
    components: {},
};